import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcFileItem} from 'exc-upload-v2';
import {environment} from '../../../environments/environment';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ApplicationService} from '../../services/application.service';

@Component({
  selector: 'app-modal-attachment-upload2',
  templateUrl: './modal-attachment-upload-v2.component.html',
  styles: [
  ]
})
export class ModalAttachmentUploadV2Component extends ExcTranslation  implements OnInit
{
  @Input() data: any;
  selectedFiles: ExcFileItem[] = [];
  uiSelectDocumentTypeIndex = this.enumSvc
    .getEnumerationList('DokTyp')
    .findIndex((e) => e.enmDefault);
  dokEigenschaftTypList: any[] = [];
  dokEigenschaftHelper: any = {};
  uiModel = {
    dokTrackingPortalShare: false,
    dokDescription: '',
    dokSize: 0,
    dokName: '',
    dok_objID: '',
    dokMIME: '',
    dokbIMG: '',
    dok_enmIdent_DokTyp: this.enumSvc.getEnumerationDefaultValue('DokTyp'),
    dokEigenschaft: [] as any[],
  };
  userType: number | any;

  private _MAXFILESIZE = environment.rest.MAXFILESIZE;
  selectedFilesChunked: ExcFileItem[][] = [];
  get MAXFILESIZE(): number {
    return this._MAXFILESIZE;
  }

  constructor(
    public popUpService: ExgModalService,
    public enumSvc: EnumerationService,
    public excSec: ExcSecurityService,
    public appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
    this.dokEigenschaftTypList = this.enumSvc.getDokEigenschaftTypList(
      this.uiModel.dok_enmIdent_DokTyp
    );



    if (this.data.selectedFiles && this.data.selectedFiles.length > 0) {
      this.data.selectedFiles.forEach((file: ExcFileItem) => {

        file.misc = file.misc || {};

        // Setze den Standardwert für dok_enmIdent_DokTyp
        file.misc.dok_enmIdent_DokTyp = file.misc.dok_enmIdent_DokTyp || 2;

      });
      this.selectedFiles = this.data.selectedFiles;
    }
  }

  setDocumentType(fileIndex: number, enumIdent: any): void {

    if (!this.selectedFiles[fileIndex].misc) {
      this.selectedFiles[fileIndex].misc = {};
    }

    Object.assign(this.selectedFiles[fileIndex].misc, { dok_enmIdent_DokTyp: enumIdent });

    /* this.uiModel.dok_enmIdent_DokTyp =
       this.enumSvc.getEnumerationList('DokTyp')[enumIdent].enmIdent;
     this.dokEigenschaftTypList = this.enumSvc.getDokEigenschaftTypList(
       this.uiModel.dok_enmIdent_DokTyp
     );
     this.dokEigenschaftHelper = {};*/
  }

  createDokEigenschaft(): void {
    this.uiModel.dokEigenschaft = [];
    // tslint:disable-next-line:forin
    for (const key in this.dokEigenschaftHelper) {
      this.uiModel.dokEigenschaft.push({
        dokEigID: key as unknown as number,
        dokEigValue: this.dokEigenschaftHelper[key],
      });
    }
  }

  upload(): void {
    if (this.getFiles().length === 0) {
      return;
    }
    this.createDokEigenschaft();
    const filesByDokTyp = new Map<number, any[]>();

    this.selectedFiles.forEach((file: any) => {

      const dokTyp = file.misc.dok_enmIdent_DokTyp;
      if (!filesByDokTyp.has(dokTyp)) {
        filesByDokTyp.set(dokTyp, []);
      }
      filesByDokTyp.get(dokTyp)?.push(file);
    });

    const formDataArray: any[] = [];

    // Rufe getFormDataChunked für jede Gruppe auf und sammle formData
    filesByDokTyp.forEach((files, dokTyp) => {
      const formData: any = ExcFileItem.getFormDataChunked(files, {
        dok_enmIdent_DokTyp: dokTyp,
        dokBeschreibung: this.uiModel.dokDescription,
        dokTrackingPortalShare: this.uiModel.dokTrackingPortalShare,
        DokEigenschaft: this.uiModel.dokEigenschaft,
      });

      // Speichere das formData im Array
      formDataArray.push(formData);
    });


    this.popUpService.action({ formDataArray });
  }

  close(): void {
    this.popUpService.close();
  }

  onFilesSelect(files: ExcFileItem[]): void {
    this.selectedFiles = this.selectedFiles.concat(files);
    this.selectedFiles.forEach((file: ExcFileItem) => {

      file.misc = file.misc || {};

      // Setze den Standardwert für dok_enmIdent_DokTyp
      file.misc.dok_enmIdent_DokTyp = file.misc.dok_enmIdent_DokTyp || 2;

    });
  }

  onFilesSelectChunked(event: any[]): void {
    for (const eventElement of event) {
      this.selectedFilesChunked.push(eventElement);
    }
  }

  delete(deleteFile: any): void {
    this.selectedFiles = this.selectedFiles.filter(
      (file: any) => file !== deleteFile
    );
  }

  proofFileSize(size: number): boolean {
    return size < this.MAXFILESIZE;
  }

  getFiles(): any[] {
    const files = this.selectedFiles.filter((file: any) =>
      this.proofFileSize(file.size)
    );
    if (!files) {
      return [];
    }
    return files;
  }
}
